import ReportAcademicContent from "../components/ReportAcademicContent";
import ReportNonAcademicContent from "../components/ReportNonAcademicContent";
import {
  AcademicIcon,
  DashboardIcon,
  FactCheckIcon,
  NonAcademicIcon,
  StarRoundIcon,
} from "../assets/icons";

export const reportCategoriesByMode = {
  default: [
    { key: "character", label: "Karakter", Icon: FactCheckIcon },
    { key: "materials", label: "Kompetensi Unggulan", Icon: StarRoundIcon },
    { key: "others", label: "Lainnya", Icon: DashboardIcon },
  ],
  nihiis: [
    { key: "character", label: "Karakter", Icon: FactCheckIcon },
    {
      key: "academic",
      label: "Akademik",
      Icon: AcademicIcon,
      report: "materials",
      Content: ReportAcademicContent,
    },
    {
      key: "materials",
      label: "Non Akademik",
      Icon: NonAcademicIcon,
      report: "others",
      Content: ReportNonAcademicContent,
    },
  ],
};

export const schoolsByMode = {
  default: {
    name: "SMK Telkom Banjarbaru",
    logo: require("../assets/dummy-logo.svg"),
  },
  almadani: {
    name: "Al Madani Islamic School",
    logo: require("../assets/almadani-logo.svg"),
  },
  nihiis: {
    name: "SD Manaaratul Iman HIIS",
    logo: require("../assets/nihiis-logo.svg"),
    infoStyle: "nihiisSchoolInfo",
    logoStyle: "nihiisSchoolLogo",
  },
};

export function deriveReportDashboardData(summary) {
  const allCharacters = summary?.characters || [];
  const charactersWithData = allCharacters.filter(
    (character) =>
      Number(character.total_indicators) > 0 ||
      character.indicators?.length > 0,
  );
  const characterData = [...charactersWithData]
    .sort((a, b) => b.point - a.point)
    .slice(0, 3);
  const ratedIndicators = allCharacters
    .flatMap((character) =>
      (character.indicators || []).map((indicator) => ({
        ...indicator,
        characterName: character.name,
      })),
    )
    .filter(
      (item) =>
        item.value !== null &&
        item.value !== undefined &&
        Number.isFinite(Number(item.value)),
    );
  const indicatorData = {
    positive: ratedIndicators
      .filter((item) => Number(item.value) >= 3)
      .sort((a, b) => b.value - a.value)
      .slice(0, 3),
    attention: ratedIndicators
      .filter((item) => Number(item.value) <= 2)
      .sort((a, b) => a.value - b.value)
      .slice(0, 3),
  };
  const characterThreshold = summary?.threshold_characters || {};
  const indicatorThreshold = summary?.threshold_indicators || {};
  const passedCount = indicatorThreshold.passed || 0;
  const failedCount = indicatorThreshold.failed || 0;
  const totalProgress = allCharacters.reduce(
    (total, character) => total + (character.point || 0),
    0,
  );

  return {
    allCharacters,
    charactersWithData,
    characterData,
    indicatorData,
    characterThreshold,
    indicatorThreshold,
    passedCount,
    failedCount,
    hasThresholdData: passedCount + failedCount > 0,
    progress:
      totalProgress > 0
        ? Math.round(totalProgress / allCharacters.length)
        : 0,
  };
}
